import * as cx from "classnames/bind";
import {
  Button,
  ButtonLink,
  Container,
  CreateListModal,
  CreateReviewModal,
  Section,
  Icon,
  Stars,
} from "components";
import OutsideClickHandler from "react-outside-click-handler";
import { default as CocktailComponent } from "components/atoms/Cocktail";
import { useRecipeLists, useSession } from "hooks";
import { useRelatedCocktails } from "hooks/algolia";
import { HomeLayout } from "layouts";
import Head from "next/head";
import Image from "next/legacy/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { runQuery } from "queries";
import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import s from "styles/Cocktail.module.scss";
import r from "styles/reviewStars.module.scss";
import {
  imageUrl,
  uniqObjArrayOld as uniqObjArray,
  uniqObjArray as uniqObjArrayNew,
  combineIngredients,
  translate,
} from "utils";
import store from "store2";
import { push } from "@socialgouv/matomo-next";
import Cookies from "js-cookie";
import { CocktailPage as Cocktail } from "components/pages/cocktails.js";

Cocktail.getLayout = (page) => {
  return <HomeLayout className={cx("Cocktail", s.Cocktail)}>{page}</HomeLayout>;
};

export async function getStaticProps({ locale, params }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
      ...(await runQuery("cocktails/single", params)).props,
    },
    revalidate: 300,
  };
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}

export default Cocktail;
